function initWqaCertificationModal() {
   //   Create a new modal instance
  const WqaCertificationModal = new BorouxModal({
    id: 'wqa-certification-modal',
    onOpen: () => {
      console.log('WQA Certification modal opened');
    },
    onClose: () => {
      console.log('WQA Certification modal closed');
    }
  });

  // Attach to all triggers with the data attribute
  document.querySelectorAll('[data-wqa-popup-toggler]').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      WqaCertificationModal.open();
    });
  });

  // Expose globally if needed
  window.wqaCertificationModal = WqaCertificationModal;
}

// Initialize after DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initWqaCertificationModal();
});
